import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export default function ThemeToggle({ onDark = false, className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  const tint = onDark ? "rgba(243,239,230,0.85)" : "var(--mp-text-strong)";

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? "Switch to daylight mode" : "Switch to showroom (dark) mode"}
      title={isDark ? "Daylight mode" : "Showroom mode"}
      className={`relative w-9 h-9 rounded-full flex items-center justify-center border ${className}`}
      style={{
        borderColor: onDark ? "rgba(243,239,230,0.25)" : "var(--mp-line)",
        backgroundColor: onDark ? "rgba(243,239,230,0.06)" : "transparent",
        color: tint,
      }}
      data-testid="theme-toggle"
    >
      <Sun
        className="w-4 h-4 absolute transition-all duration-500"
        style={{ opacity: isDark ? 0 : 1, transform: isDark ? "rotate(-90deg) scale(0.6)" : "none" }}
      />
      <Moon
        className="w-4 h-4 absolute transition-all duration-500"
        style={{ opacity: isDark ? 1 : 0, transform: isDark ? "none" : "rotate(90deg) scale(0.6)" }}
      />
    </button>
  );
}
